import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  height: calc(100vh - 100px);
  flex-direction: column;
  justify-content: space-between;
`;

export const Space = styled.div`
  height: 34px;
`;
